import React, { createContext, useMemo } from 'react'
import { UserGroups } from 'pages/TeamMembers/const'
import type { Profile } from 'types/authentication/Profile'

export interface ProfileContext {
  profile: Profile
  isLoading: boolean
  viewOnly: boolean
  hasCollaboratorRoleGroup: boolean
}

export const ProfileContext = createContext<ProfileContext>({
  profile: { twoFactorEnabled: false } as Profile,
  isLoading: false,
  viewOnly: false,
  hasCollaboratorRoleGroup: false,
})

interface ProfileContextProviderProps {
  profile: Profile
  isLoading: boolean
  children: React.ReactNode
}

export const ProfileContextProvider = ({
  children,
  profile,
  isLoading,
}: ProfileContextProviderProps) => {
  const { viewOnly, roleGroups } = profile || {}
  const hasCollaboratorRoleGroup = !!roleGroups?.includes(UserGroups.Collaborator)
  const value = useMemo<ProfileContext>(
    () => ({
      profile,
      isLoading,
      viewOnly: viewOnly,
      hasCollaboratorRoleGroup,
    }),
    [profile, isLoading]
  )

  return <ProfileContext.Provider value={value}>{children}</ProfileContext.Provider>
}
